// extracted by mini-css-extract-plugin
export default {"slide":"travelslide_slide__iR8kC","text":"travelslide_text__k7-kx","logo":"travelslide_logo__5RSDj"};